import { api } from '../utils/axios-utils';

/*
const elements = { "_id": "6284a6bb10de9f877e0dfbc2", "id": "6284a6bb10de9f877e0dfbc1", "createDate": 1652860603865, "owner": "3LygTR9h9VQdfuUNhi1HxI1LdFW2", "depth": 0, "rootId": "6284a6bb10de9f877e0dfbc1", "parentId": null, "sharedFrom": null, "title": "TESTE formal", "overarchingVP": "", "customerSegmentForVP": "", "timelineEVP": 11, "elements": [{ "description": "gdfg", "index": 1, "id": "523d69ac-c4f3-4956-8412-3068f2939b29", "position": { "x": 750, "y": 400 }, "type": "MAJOR_COMPLEMENT", "abilityToContribute": "0.4", "attachments": [], "providedBy": "MY_ORGAZINATION", "willingnessToContribute": "0.8", "actorType": "Corporation", "availableIn": "11", "contributingAssumption": "dfg", "contributionBasis": "fdg" }, { "description": "Public Transport", "index": 2, "id": "9d5b9071-723b-4f6b-27fd-a8a7832ceb49", "position": { "x": 670, "y": 710 }, "type": "MAJOR_COMPLEMENT", "abilityToContribute": "0.3", "attachments": [], "providedBy": "MY_ORGAZINATION", "willingnessToContribute": "0.4", "actorType": "Corporation", "availableIn": "11", "contributingAssumption": "fddg", "contributionBasis": "fdgfd" }, { "id": "9e6a8ea7-03de-45f5-2099-c3b9c293b016", "type": "VALUE_COMPLEMENT", "reference": null, "description": "fdsfg", "providedBy": "MY_ORGAZINATION", "actorType": null, "contributionBasis": "fdg", "contributingAssumption": "dfg", "availableIn": "4", "abilityToContribute": "0.4", "willingnessToContribute": "0.6", "parentId": "523d69ac-c4f3-4956-8412-3068f2939b29", "position": { "x": 1066, "y": 114 }, "attachments": [] }, { "id": "bb398ea9-0f09-4ff5-8c09-be738e359cea", "type": "VALUE_COMPLEMENT", "reference": null, "description": null, "providedBy": null, "actorType": null, "contributionBasis": null, "contributingAssumption": null, "availableIn": null, "abilityToContribute": null, "willingnessToContribute": null, "parentId": "9e6a8ea7-03de-45f5-2099-c3b9c293b016", "position": { "x": 1066, "y": -186 }, "attachments": [] }, { "id": "ec92006d-eee0-4271-1cc0-059525569de5", "type": "VALUE_COMPLEMENT", "reference": null, "description": "ddfgdfgfd", "providedBy": "MY_ORGAZINATION", "actorType": null, "contributionBasis": null, "contributingAssumption": null, "availableIn": null, "abilityToContribute": null, "willingnessToContribute": null, "parentId": "9d5b9071-723b-4f6b-27fd-a8a7832ceb49", "position": { "x": 670, "y": 1010 }, "attachments": [] }, { "id": "888859b3-7698-4731-296d-0ef95a7fcfaa", "type": "VALUE_COMPLEMENT", "reference": null, "description": "fg cvfdvdfvfdv", "providedBy": "MY_ORGAZINATION", "actorType": null, "contributionBasis": null, "contributingAssumption": null, "availableIn": null, "abilityToContribute": null, "willingnessToContribute": null, "parentId": "ec92006d-eee0-4271-1cc0-059525569de5", "position": { "x": 1040, "y": 990 }, "attachments": [] }, { "id": "b6908bf8-9da3-45de-121f-74465c7e3ba4", "type": "VALUE_COMPLEMENT", "reference": null, "description": "vfdfd fdbfbfdbfdb", "providedBy": "MY_ORGAZINATION", "actorType": null, "contributionBasis": null, "contributingAssumption": null, "availableIn": null, "abilityToContribute": null, "willingnessToContribute": null, "parentId": "888859b3-7698-4731-296d-0ef95a7fcfaa", "position": { "x": 1366, "y": 662 }, "attachments": [] }, { "id": "9ccefac6-2632-43b1-8685-d2a16f802cc7", "type": "VALUE_COMPLEMENT", "reference": null, "description": "fdfd fdgfdg fgfgfdgfdgd", "providedBy": "MY_ORGAZINATION", "actorType": null, "contributionBasis": null, "contributingAssumption": null, "availableIn": null, "abilityToContribute": null, "willingnessToContribute": null, "parentId": "b6908bf8-9da3-45de-121f-74465c7e3ba4", "position": { "x": 1564, "y": 374 }, "attachments": [] }] };
*/

export async function getScenario(id) {
  return (await api.get(`/scenarios/${id}`)).data;
}

export async function getScenarios() {
  // return new Promise((res) => res({ elements: INITIAL_ELEMENTS }));
  return (await api.get(`/scenarios`)).data;
}

export async function createScenario(values) {
  return (await api.post(`/scenarios`, values)).data;
}

export async function deleteScenario(id) {
  return (await api.delete(`/scenarios/${id}`)).data;
}

export async function saveScenario(id, values) {
  return (await api.post(`/scenarios/${id}`, values)).data;
}

export async function createComplements(scenarioId, values) {
  return (await api.post(`/scenarios/${scenarioId}/complements/major-chain`, values)).data;
}

export async function createComplement(scenarioId, values) {
  return (await api.post(`/scenarios/${scenarioId}/complements`, values)).data;
}

export async function removeValueComplement(scenarioId, id) {
  return (await api.delete(`/scenarios/${scenarioId}/complements/${id}`)).data;
}

export async function createMajorComplement(scenarioId, values) {
  return (await api.post(`/scenarios/${scenarioId}/complements/major`, values)).data;
}

export async function removeMajorComplement(scenarioId, id, idsToRemove, majorComplementsToUpdate) {
  return (await api.post(`/scenarios/${scenarioId}/complements/major/${id}/delete`, { idsToRemove, majorComplementsToUpdate })).data;
}

export async function createValueComplement(scenarioId, values) {
  return (await api.post(`/scenarios/${scenarioId}/value-complements`, values)).data;
}

export async function updateComplement(scenarioId, id, values) {
  return (await api.patch(`/scenarios/${scenarioId}/complements/${id}`, values)).data;
}

export async function updateComplementPosition(scenarioId, id, values) {
  return (await api.patch(`/scenarios/${scenarioId}/complements/${id}/position`, values)).data;
}

export async function updateValueProposition(scenarioId, values) {
  return (await api.patch(`/scenarios/${scenarioId}/value-proposition`, values)).data;
}

export async function shareScenario(scenarioId, values) {
  return (await api.post(`/scenarios/${scenarioId}/share`, values)).data;
}

export async function createChildScenario(scenarioId, values) {
  return (await api.post(`/scenarios/${scenarioId}/child`, values)).data;
}

export async function getScenarioTree(scenarioRootId) {
  return (await api.get(`/scenarios/${scenarioRootId}/tree`)).data;
}

export async function downloadFile(fileKey) {
  const response = (await api.get(`/files`, { params: { fileKey }, responseType: 'blob' }));
  const fileName = response.headers['x-file-name'] || 'thrive_download';
  clientDownloadFile(response.data, fileName);
}

export async function downloadScenario(id) {
  const response = (await api.get(`/scenarios/${id}/download`, { responseType: 'blob' }));
  const fileName = response.headers['x-file-name'] || `scenario-${id}.json`;
  clientDownloadFile(response.data, fileName);
}

export async function uploadScenario(values) {
  return (await api.post(`/scenarios/upload`, values)).data;
}

export function clientDownloadFile(file, fileName) {
  const url = window.URL.createObjectURL(new Blob([file]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  link.remove();
}
